import { OktaUserInfo } from './okta-user-info';
import { getCurrentFeatureCode, setCurrentFeatureCode } from './utils';
import { useIsAuthenticated } from './hooks';
import { saveLog } from '../utils';
import { Loading } from '../components/Loading';
import { defaultCache } from '../cache';
import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router';
import {
  useOktaAuthnAppContext,
  useOktaAuthnOktaAuth,
} from '@ssar-app/okta-authn-react';

export const Logout = () => {
  const email = OktaUserInfo.getOktaUserInfo().userName;
  const oktaAuth = useOktaAuthnOktaAuth();
  const history = useHistory();
  const isAuthed = useIsAuthenticated();

  const featureCode = getCurrentFeatureCode();
  const { oktaClientCode, setCurrentOktaClientCode } = useOktaAuthnAppContext();

  const doLogout = useCallback(() => {
    defaultCache.clearAll();
    const setBackFeatureAndOktaCode = () => {
      if (featureCode) {
        setCurrentFeatureCode(featureCode);
      }
      if (oktaClientCode) {
        setCurrentOktaClientCode(oktaClientCode);
      }
    };

    const logoutUri = '/';

    if (oktaAuth) {
      oktaAuth.tokenManager.clear();
      oktaAuth
        .signOut({
          postLogoutRedirectUri: history.createHref({
            pathname: logoutUri,
          }),
          accessToken: oktaAuth?.authStateManager.getAuthState()?.accessToken,
        })
        .finally(setBackFeatureAndOktaCode);
    } else {
      setBackFeatureAndOktaCode();
      history.replace(logoutUri);
    }
  }, [
    featureCode,
    history,
    oktaAuth,
    oktaClientCode,
    setCurrentOktaClientCode,
  ]);
  useEffect(() => {
    if (isAuthed) {
      saveLog('Logout', `Logout successful by ${email}`)
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          doLogout();
        });
    } else {
      doLogout();
    }
  }, [doLogout, email, isAuthed]);

  return (
    <div>
      <br />
      <br />
      <Loading message='Logging out...'></Loading>
    </div>
  );
};
